import { Alert, Form } from 'antd';

import { ImageIcon } from 'app/components/commons/icons/ImageIcon';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';

import { PackExperiences } from './PackExperiences/PackExperiences';
import { PackRooms } from './PackRooms/PackRooms';

export const ExperiencesAndRooms = () => {
  const form = Form.useFormInstance<Partial<PackResponse>>();
  const isDaytime = Form.useWatch(['isDaytime'], form);

  return (
    <>
      {!isDaytime && (
        <Alert
          type="info"
          className="mb-24"
          message={
            <div className="alert-content">
              <ImageIcon />
              <div className="alert-text">
                <div className="alert-title">Package cover</div>
                <div className="alert-text">
                  Make sure you put the 3 most representative included
                  activities first because they will compose the package cover.
                </div>
              </div>
            </div>
          }
        />
      )}
      <PackExperiences />
      <PackRooms />
    </>
  );
};
